module.exports = "https://static.wmbcdn.com/uniweb/images/59a69c9f9cb3f00eafc82d2c7dcc97dc.svg";